<template>
  <v-modal v-model="showModel" handle-click-bg :animation="screen.breakPoint.tabPort ? 'slide-down' : 'slide-up'" fit-content :full="!screen.breakPoint.tabPort" :position="screen.breakPoint.tabPort ? 'top' : 'bottom'">
    <template v-slot:header>
      {{ $t('views.Dashboard.Settlements.addInvoice') }}
    </template>

    <div v-if="currentContract">
      <v-input disabled :value="currentContract.fullName" :placeholder="$t('views.Orders.contractSelect.label')" class="mb-2"></v-input>
    </div>
    <v-input :error="errors.amount ? $t(errors.amount) : null" :placeholder="$t('views.Components.AddOrder.orderAmount')" v-model="computedAmount" class="mb-05" type-name="number" :disabled="loading"></v-input>
    <div class="text--small text-color-space mb-1">{{ $t('components.AddInvoice.minimum') }}: <span class="text-color-black">{{ toCurrency(minimum, currency) }}</span>, {{ $t('components.AddInvoice.recommended') }}: <span class="text-color-black">{{ toCurrency(defaultAmount, currency) }}</span></div>

    <template v-slot:footer>
      <v-button color="success" width="full" @click="validate" :loading="loading" v-if="!invoiceLink">{{ $t('views.Dashboard.Settlements.addInvoice') }}</v-button>
      <div v-if="invoiceLink"  class="d-flex justify-center">
        <action-link icon-left="icon-download" size="small" color="primary" @click="getInvoice" target="_blank" class="py-1 text-center">{{ $t('views.Dashboard.Settlements.downloadInvoicePDF') }}</action-link>
      </div>
    </template>
  </v-modal>
</template>

<script>
import vButton from '@/ui/controls/vButton'
import vModal from '@/ui/modals/vModal'
import vInput from '@/ui/controls/vInput'
import ActionLink from '@/ui/controls/ActionLink'

import screen from '@/mixins/screen'
import currContractId from '@/mixins/currContractId'
import contracts from '@/mixins/contracts'
import toCurrency from '@/mixins/toCurrency'

export default {
  mixins: [screen, currContractId, contracts, toCurrency],

  props: {
    loading: {
      type: Boolean,
      default: false
    },

    value: {
      type: Boolean,
      default: false
    },

    defaultAmount: {
      type: Number,
      default: 0
    },

    invoiceLink: {
      type: String,
      default: null
    },

    currency: {
      type: String,
      default: null
    },

    minimum: {
      type: Number,
      default: 0
    }
  },

  data () {
    return {
      formData: {
        amount: null
      },
      errors: {
        amount: null
      }
    }
  },

  computed: {
    computedAmount: {
      get () {
        return this.formData.amount
      },

      set (val) {
        this.formData.amount = +val
      }
    },

    showModel: {
      get () {
        return this.value
      },

      set (val) {
        if (!val) {
          this.$emit('onClose')
        }
        this.$emit('input', JSON.parse(val))
      }
    },
    currentContract () {
      if (!this.currContractId || !this.contracts) {
        return null
      }
      return this.contracts.find(contract => contract.id === this.currContractId)
    }
  },

  methods: {
    validate () {
      if (typeof this.computedAmount === 'undefined' || this.computedAmount === null || this.computedAmount === '') {
        this.errors.amount = 'errors.Components.AddOrder.validation.mustNotBeEmpty'
      }

      if (this.computedAmount <= 0) {
        this.errors.amount = 'errors.Components.AddOrder.validation.mustBeGreaterThanZero'
      }

      if (this.computedAmount < this.minimum) {
        this.errors.amount = 'errors.Components.AddOrder.validation.mustBeGreaterThanMinAmount'
      }

      if (Object.keys(this.errors).some(key => this.errors[key] && true)) {
        return
      }

      this.$emit('add', {
        amount: +this.computedAmount,
        partnerContractId: +this.currContractId
      })
    },

    getInvoice () {
      window.open(this.invoiceLink, '_blank')
    }
  },

  mounted () {
    this.formData.amount = +(this.defaultAmount < this.minimum ? this.minimum : this.defaultAmount)
  },

  watch: {
    computedAmount () {
      this.$emit('clear')
    },

    formData: {
      handler: function () {
        this.errors = {
          amount: null
        }
      },
      deep: true
    },

    showModel (val) {
      if (!val) {
        this.formData = {
          amount: null
        }
      } else {
        this.formData = {
          amount: this.defaultAmount
        }
      }
    }
  },

  components: {
    vButton,
    vModal,
    vInput,
    ActionLink
  }
}
</script>
